<template>
  <div>
    <v-card-text>
      <template v-if="matches!=null" class="pa-0">
        <v-container fluid grid-list-md>
          <v-layout row wrap justify-center v-if="matches">
            <!-- <v-flex v-for="(match, idx) in matches_a" :key="match.roundName" v-bind="{ [`xs${match.flex}`]: true }" lg4 sm5 > -->
            <v-flex v-for="(match, idx) in matches" :key="'mafl'+idx" xs12 lg4 sm5>
              <v-card style="border-radius: 8px">
                <v-card-title class="pa-1">
                  <v-expansion-panel class="elevation-0">
                    <v-expansion-panel-content lazy class="elevation-0">
                      <div slot="header">Jogo {{idx+1}}</div>
                      <template v-slot:actions>
                        <v-layout>
                          <v-flex>
                            <h3 style="color:blue;" v-if="match.ended_as=='w.o'">{{match.ended_as}}</h3>
                          </v-flex>
                          <v-icon color="primary">info</v-icon>
                        </v-layout>
                      </template>
                      <div class="text-xs-right">
                        <v-icon>place</v-icon>
                        {{match.place}}
                        <v-icon class="mx-1">today</v-icon>
                        {{match.date3}}
                        <v-icon class="mx-1">access_time</v-icon>
                        {{match.time}}
                      </div>
                      <v-divider inset></v-divider>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <!-- COLOCAR PARA EDITAR/APAGAR O JOGO -->
                </v-card-title>
                <v-layout
                  justify-space-around
                  align-center
                  @click="see_match(match)"
                  :style="{cursor: match.ended==true? 'pointer' : 'arrow'}"
                >
                  <v-flex xs5>
                    <v-layout align-center justify-center column>
                      <v-avatar :size="avatarSize" color="grey lighten-4">
                        <v-icon
                          v-if="!match.home_team.data.attributes.team_logo"
                          :size="avatarSize*56/100"
                          color="grey lighten-1"
                        >fa-shield-alt</v-icon>

                        <v-img
                          aspect-ratio="1"
                          class="grey lighten-4"
                          style="border-radius: 12px"
                          contain
                          v-if="match.home_team.data.attributes.team_logo"
                          :src="match.home_team.data.attributes.team_logo"
                          alt="alt"
                        />
                        <!-- <span
                        v-else
                        class="white--text display-3"
                        >{{team_inicials(match.home_team.data.attributes.team_name)}}</span>-->
                      </v-avatar>
                      <h3 class="text-xs-center">{{match.home_team.data.attributes.team_name}}</h3>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2>
                    <v-layout row justify-space-around align-content-center>
                      <h4 v-if="match.ended">{{match.homeGoals}} x {{match.awayGoals}}</h4>
                      <h1 style="color:grey;" v-if="!match.ended">?</h1>
                    </v-layout>

                    <v-layout
                      row
                      wrap
                      justify-space-around
                      align-content-center
                      v-if="match.ended && match.tied && match.round_kind=='finals'"
                    >
                      <h5 style="color:grey;">pênaltis</h5>
                      <h5
                        style="color:grey;"
                      >{{match.homeBreakerGoals}} x {{match.awayBreakerGoals}}</h5>
                    </v-layout>
                  </v-flex>
                  <v-flex xs5>
                    <v-layout align-center column>
                      <v-avatar :size="avatarSize" color="grey lighten-4">
                        <v-icon
                          v-if="!match.away_team.data.attributes.team_logo"
                          :size="avatarSize*56/100"
                          color="grey lighten-1"
                        >fa-shield-alt</v-icon>
                        <v-img
                          aspect-ratio="1"
                          class="grey lighten-4"
                          style="border-radius: 12px"
                          contain
                          v-if="match.away_team.data.attributes.team_logo"
                          :src="match.away_team.data.attributes.team_logo"
                          alt="alt"
                        />
                        <!-- <span
                        v-else
                        class="white--text display-3"
                        >{{team_inicials(match.away_team.data.attributes.team_name)}}</span>-->
                      </v-avatar>
                      <h3 class="text-xs-center">{{match.away_team.data.attributes.team_name}}</h3>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-divider light class="mt-2"></v-divider>
                <v-card-actions v-if="is_owner">
                  <v-flex xs12>
                    <v-layout row wrap justify-space-around>
                      <!-- <v-spacer></v-spacer> -->
                      <v-btn
                        flat
                        v-if="!match.ended"
                        icon
                        color="red"
                        router
                        @click="goToMatch(match.id)"
                      >
                        <v-icon color="red">wifi_off</v-icon>
                      </v-btn>
                      <v-btn block v-if="match.ended" color="grey dark-2" router>
                        <v-icon left color="white">description</v-icon>Finalizado
                      </v-btn>

                      <v-btn
                        flat
                        v-if="!match.ended"
                        icon
                        color="primary"
                        @click="editGame = true, edit_id=match.id"
                      >
                        <v-icon>create</v-icon>
                      </v-btn>
                      <v-btn
                        flat
                        v-if="!match.ended"
                        icon
                        color="primary"
                        @click="deleteMatch(match.id)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex v-if="!(matches % 3) && matches.length>3" xs12 lg4 sm5></v-flex>
          </v-layout>
        </v-container>
      </template>
      <template v-if="matches==null" class="pa-0">
        <v-flex xs10 offset-xs1>
          <v-alert color="primary" :value="true" style="border-radius: 12px;">
            <v-layout row wrap justify-center>Carregando...</v-layout>
            <v-progress-linear color="white" :indeterminate="true"></v-progress-linear>
          </v-alert>
        </v-flex>
      </template>
    </v-card-text>

    <v-dialog v-model="editGame" width="500" persistent v-if="editGame && oneMatch">
      <v-card style="border-radius:8px">
        <v-toolbar color="primary" dark>
          <v-toolbar-title class="white--text">Editar Jogo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="white" flat icon @click="editGame=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-text-field
            v-model="oneMatch.attributes.place"
            color="primary"
            box
            label="Local da Partida"
          ></v-text-field>
          <v-layout row wrap justify-space-around>
            <v-flex xs11 sm5>
              <v-dialog
                ref="dialogTime"
                v-model="modalTime"
                :return-value.sync="oneMatch.attributes.time"
                lazy
                transition="scale-transition"
                width="290px"
              >
                <template>
                  <v-text-field
                    slot="activator"
                    v-model="oneMatch.attributes.time"
                    label="Horário da Partida"
                    prepend-icon="access_time"
                    readonly
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="modalTime"
                  v-model="oneMatch.attributes.time"
                  full-width
                  format="24hr"
                >
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="modalTime=false">Cancel</v-btn>
                  <v-btn
                    flat
                    color="primary"
                    @click="$refs.dialogTime.save(oneMatch.attributes.time)"
                  >OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-flex>

            <v-flex xs11 sm5>
              <v-dialog
                ref="dialogDate"
                v-model="modalDate"
                :return-value.sync="date2edit"
                persistent
                lazy
                width="290px"
              >
                <template>
                  <v-text-field
                    slot="activator"
                    v-model="oneMatch.attributes.date2"
                    label="Dia"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date2edit" scrollable locale="pt-br">
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="modalDate = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.dialogDate.save(date2edit)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
          </v-layout>

          <v-layout row wrap justify-space-around>
            <v-flex xs11 sm5>
              <v-select
                :items="allChampTeams"
                item-value="id"
                item-text="team_name"
                v-model="oneMatch.attributes.team_A_id"
                label="Time da Casa"
              ></v-select>
            </v-flex>
            <v-flex xs11 sm5>
              <v-select
                :items="allChampTeams"
                item-value="id"
                item-text="team_name"
                v-model="oneMatch.attributes.team_B_id"
                label="Time Visitante"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn
            color="primary"
            flat
            :disabled="!oneMatch.attributes.team_A_id && !oneMatch.attributes.team_B_id"
            @click="submitEditGame()"
          >Salvar jogo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

  <!-- //////////// -->
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import Api from "../../../api/index";

export default {
  data() {
    return {
      key: null,
      matches: null,
      avatarSize: 80,
      editGame: false,
      modalTime: false,
      modal2: false,
      date2format: null,
      date2edit: null,
      modalDate: null,
      date: new Date().toISOString().substr(0, 10)
    };
  },
  methods: {
    submitEditGame() {
      this.loadTxt = "Salvando";
      this.loading = true;
      this.editGame = false;
      this.oneMatch.attributes.match_time = this.oneMatch.attributes.time;
      this.oneMatch.attributes.match_date = this.oneMatch.attributes.date2;
      this.updateMatchDetails({ match: this.oneMatch.attributes }).then(() => {
        this.getRoundMatches(this.$route.params.round);
      });
    },
    deleteMatch(id) {
      this.$http
        .delete(`api/v1/matches/${id}`)
        .then(data => this.getRoundMatches(this.$route.params.round))
        .catch(error => {
          console.log({ error });
        });
    },
    goToMatch(id) {
      this.$router.push({ path: `/sumula/${id}` });
    },
    see_match(match) {
      if (match.ended) this.$router.push(`/sumula/${match.id}`);
    },
    getRoundMatches(id) {
      Api.Championship.indexRoundMatches(id)
        .then(r => r.data)
        .then(data => {
          console.log({ data });
          setTimeout(() => {
            this.matches = data.data.map(o => o.attributes);
          }, 1000);
        });
    },
    ...mapActions({
      // function: 'Module/action'
      getOneMatch: "Championship/showMatch",
      getChampTeams: "ChampTeam/index",
      updateMatchDetails: "Championship/updateMatchDetails"
    })
  },
  created() {
    this.getRoundMatches(this.$route.params.round);
  },
  computed: {
    is_owner() {
      return this.oneChampionship.data.attributes.can_edit;
    },
    ...mapState({
      oneChampionship: state => state.Championship.oneChampionship,
      oneMatch: state => state.Championship.oneMatch,
      allChampTeams: state => state.ChampTeam.allChampTeams,
      createMatchWasGood: state => state.Championship.createMatchWasGood

      // data: state=> state.Module.state_var
    })
  },
  watch: {
    "$route.params.round"(nv, ov) {
      if (nv) {
        this.matches = null;
        this.getRoundMatches(this.$route.params.round);
      } else if (nv == false) {
      }
    },
    updateMatchWasGood(nv, ov) {
      if (nv) {
        setTimeout(() => {
          this.loading = false;
          this.loadTxt = null;
        }, 500);
      } else if (nv == false) {
      }
    },
    editGame(nv, ov) {
      if (nv && this.edit_id) {
        this.loading = true;
        this.loadTxt = "Carregando";
        this.getOneMatch({ match_id: this.edit_id });
        //

        if (!this.allChampTeams) {
          this.getChampTeams(this.$route.params.id);
        }
      } else if (nv == false) {
      }
    },
    createMatchWasGood(nv, ov) {
      if (nv) {
        this.getRoundMatches(this.$route.params.round);
      }
    },
    oneMatch(nv, ov) {
      if (nv) {
        this.loading = false;
        this.loadTxt = null;
      } else if (nv == false) {
      }
    }
  }
};
</script>

<style scoped>
</style>